import { type ComponentProps } from 'react';
import { cn } from '../lib/utils';

function Collapsible({ className, ...props }: ComponentProps<'details'>) {
   return (
      <details data-slot="collapsible" className={cn('group/collapsible', className)} {...props} />
   );
}

function CollapsibleTrigger({ className, ...props }: ComponentProps<'summary'>) {
   return (
      <summary
         data-slot="collapsible-trigger"
         className={cn('list-none [&::-webkit-details-marker]:hidden', className)}
         {...props}
      />
   );
}

function CollapsibleContent({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="collapsible-content" className={cn(className)} {...props} />;
}

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
